import { CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, signal, ViewChild, ViewEncapsulation, WritableSignal, OnDestroy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatDatepickerInputEvent, MatDatepickerModule, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { LoaderComponent } from '@app/lib/components/loader/loader.component';
import { Holiday, IAssignedTask, ITableConfig, TaskModel } from '../models/assigned-task.model';
import { AssignedTaskService } from '../services/assigned-task.service';
import { IResponse } from '@app/lib/models/response.model';
import { FormsModule } from '@angular/forms';
import { CalenderCaseService } from '../services/calender-case.service';
import { MatTabsModule } from '@angular/material/tabs';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TAny } from '@app/lib/models/common.type';
import { DialogMessageComponent } from '../dialog-message/dialog-message.component';
import { MatDialog } from '@angular/material/dialog';
import { FormControl } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { ICaseSearchRequestBody, ISearchRequestParams } from '../models/case-assignment.model';
import { CaseNumberDialogComponent } from '@app/lib/components/case-number-dialog/case-number-dialog.component';
import { AddPartyDialogComponent } from '../document-reception/add-party-dialog/add-party-dialog.component';
import { Router } from '@angular/router';
import { DialogService } from '@app/lib/services/dialog.service';
import { Subscription } from 'rxjs';
import { ILoginData } from '@app/lib/models/login.model';
import { ECourtId } from '../models/constant';
import { AppConstantsService } from '../services/app-constants.service';



@Component({
  selector: 'app-assigned-tasks',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatTableModule,
    MatSortModule,
    FormsModule,
    DatePipe,
    MatTooltipModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCardModule,
    MatTabsModule,
    MatProgressSpinner,
    MatFormField,
    ReactiveFormsModule,
    MatInputModule
  ],
  providers: [
    DatePipe
  ],
  templateUrl: './assigned-tasks.component.html',
  styleUrl: './assigned-tasks.component.scss',
  encapsulation: ViewEncapsulation.None,
})


export class AssignedTasksComponent implements OnInit, AfterViewInit, OnDestroy {

  @ViewChild(MatSort) matSortRef!: MatSort;
  @ViewChild('calendarRef') calendarRef: any;

  tblConfig: ITableConfig[] = [
    { column: 'courtCaseNumber', label: 'Case/ Appeal No', styleClass: '' },
    { column: 'dueDate', label: 'Due', styleClass: 'text-nowrap' },
    // { column: 'typeId', label: 'Type', styleClass: '' },
  ];

  displayedColumns: string[] = this.tblConfig.map(item => item.column);
  calendarExpanded = true;
  selectedDate: Date | null = null;
  startAtDate: Date = new Date();
  dataSource: MatTableDataSource<IAssignedTask> = new MatTableDataSource<IAssignedTask>([]);
  groupedTasks: { [groupName: string]: IAssignedTask[] } = {};
  loader: WritableSignal<boolean> = signal(false);
  showFilterIcon: boolean = false;
  showFilterTextbox: boolean = false;
  filterValue: string = '';
  selectedRow: any = null;
  hoveredRow: any = null;
  courtIdData: number | null = null;
  isSupremeCourtFlg: boolean = false;
  isCOAFlg: boolean = false;
  expandedGroups: { [groupName: string]: boolean } = {};
  isLoading = true;
  isCalendorLoading = true;
  sortBy: string = 'courtCaseNumber'; // Default sorting field
  sortAscending: boolean = true; // Default sorting order
  filteredTasks: { [groupName: string]: IAssignedTask[] } = {};
  filteredTaskKeys: string[] = [];
  searchQuery = new FormControl('');
  holiday: Holiday[] = [];
  hoveredDescription: string | null = null;
  holidaySet: Set<string> = new Set();
  holidayLoaded = false;
  searchDate: Date | null = null;
  searchCaseNo: string = '';
  searchPartyId: string = '';
  searchPartyName: string = '';
  holidayDescriptionMap: Map<string, string> = new Map();
  private calendarMutationObserver: MutationObserver | null = null;
  private calendarSub!: Subscription;


  constructor(
    private assignTaskService: AssignedTaskService,
    private calenderCaseService: CalenderCaseService,
    private dialog: MatDialog,
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private dialogService: DialogService,
    private constantsService: AppConstantsService
  ) { }
  public isTaskCompleted: WritableSignal<boolean> = signal(false);

  ngOnInit() {
    this.getConstants();
    this.getCourtNameData();
    this.getHoliday();
    this.getTasks();


    this.dataSource.filterPredicate = (data: IAssignedTask, filter: string) => {
      return data.courtCaseNumber?.toLowerCase().includes(filter.toLowerCase());
    };
  }


  ngAfterViewInit(): void {

    this.dataSource.sort = this.matSortRef;

    this.calendarSub = this.calendarRef.stateChanges.subscribe(() => {
      const currentMonth = this.calendarRef.activeDate;
      this.applyHolidayTooltips(currentMonth);
    });

  }


  ngOnDestroy(): void {
    this.calendarMutationObserver?.disconnect();
  }

  ngAfterViewChecked() {
    if (!this.holidayLoaded || !this.calendarRef) return;

    const cells = document.querySelectorAll('.mat-calendar-body-cell-content');
    const month = this.startAtDate.getMonth();
    const year = this.startAtDate.getFullYear();

    cells.forEach(cell => {
      const dayText = (cell as HTMLElement).innerText.trim();
      if (!/^\d+$/.test(dayText)) return;

      const date = new Date(year, month, +dayText);
      const formattedDate = this.formatHolidayDate(date); // e.g., 05/30/2025

      const tooltip = this.holidayDescriptionMap.get(formattedDate);
      if (tooltip) {
        (cell as HTMLElement).setAttribute('title', this.capitalize(tooltip));
      } else {
        (cell as HTMLElement).removeAttribute('title');
      }
    });
  }
  private capitalize(text: string): string {
    return text
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  getCourtNameData(): ILoginData | null {
    try {
      const userData = localStorage.getItem('userData') as string;
      const userData2 = userData ? JSON.parse(userData) : null;
      this.courtIdData = userData2.courtId;


      //supreme court
      if (this.constantsService.SC_COURT_LEVEL_ID === this.constantsService.COURT_LEVEL) {
        this.isSupremeCourtFlg = true;
      } else if (this.constantsService.COA_COURT_LEVEL_ID === this.constantsService.COURT_LEVEL) {
        this.isCOAFlg = true;
      }
      //console.log(`userData2 :: ${userData2}`)
      // return userData ? JSON.parse(userData) : null;
      return userData2;
    } catch (err) {
      return null
    }
  }
  onTabChange() {
    // 1. Clear the value in the FormControl
    this.searchQuery.setValue('');

    // 2. Trigger the search function with an empty string to reset the list
    this.onSearch('');

    // Optional: If you have a specific variable holding filtered keys, 
    // ensure it resets here if onSearch doesn't fully cover it.
  }

  applyHolidayTooltips(date: any): void {
    const cells = document.querySelectorAll('.mat-calendar-body-cell-content');
    this.startAtDate = date;
    const month = this.startAtDate.getMonth();
    const year = this.startAtDate.getFullYear();

    cells.forEach(cell => {
      const dayText = (cell as HTMLElement).innerText.trim();
      if (!/^\d+$/.test(dayText)) return;

      const date = new Date(year, month, +dayText);
      const formattedDate = this.formatHolidayDate(date); // e.g., 05/30/2025

      const tooltip = this.holidayDescriptionMap.get(formattedDate);
      if (tooltip) {
        (cell as HTMLElement).setAttribute('title', this.capitalize(tooltip));
      } else {
        (cell as HTMLElement).removeAttribute('title');
      }
    });

  }



  onViewChanged(test: string) {
    //console.log('Month changed:', test);

  }
  onMonthChanged(_: Date) {
    // Force view update to re-apply tooltips
    setTimeout(() => this.changeDetectorRef.detectChanges(), 50);

  }
  highlightHolidayDates = (date: Date): string => {
    if (!this.holidayLoaded) {
      this.getHoliday();
    }
    const formatted = this.formatHolidayDate(date);
    return this.holidaySet.has(formatted) ? 'holiday-highlight' : '';
  };



  public formatHolidayDate(date: Date): string {
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  }


  public getTasks() {
    this.isLoading = true; // Set loading state to true before fetching data
    this.searchQuery.setValue(''); // Clear search input
    this.onSearch(''); // Reset filtered list
    this.assignTaskService.getTasks().subscribe({
      next: (res: IResponse<IAssignedTask[]>) => {
        if (Array.isArray(res.data)) {
          this.groupTasks(res.data);
        }
        this.isLoading = false; // Disable loading after receiving data
      },
      error: () => {
        this.isLoading = false; // Disable loading even if an error occurs
        console.error('Error fetching tasks');
      }
    });

  }
  public getConstants() {
    this.assignTaskService.getConstants().subscribe({
      next: (res: IResponse<TAny>) => {
        this.constantsService.setConstants(res);
      },
      error: () => {
        this.isLoading = false; // Disable loading even if an error occurs
        console.error('Error fetching tasks');
      }
    });

  }
  getHoliday() {
    this.isCalendorLoading = true;
    this.holidayLoaded = true;

    this.assignTaskService.getHoliday().subscribe({
      next: (res: IResponse<Holiday[]>) => {
        if (Array.isArray(res.data)) {
          this.holiday = res.data;
          this.holidaySet = new Set(res.data.map(h => h.holidayDate));
          this.holidayDescriptionMap = new Map(res.data.map(h => [h.holidayDate, h.description]));
          this.isCalendorLoading = false;

          // ⏳ Wait for view update, then trigger re-render of calendar
          setTimeout(() => {
            if (this.calendarRef?.updateTodaysDate) {
              this.calendarRef.updateTodaysDate();
            }
          }, 0);
        } else {
          this.isCalendorLoading = false;
        }
      },
      error: () => {
        this.isCalendorLoading = false;
        console.error('Error fetching holidays');
      }
    });
  }

  onSearch(query: string) {
    query = (query ?? '').trim().toLowerCase();

    if (!query || query.length < 3) {
      this.filteredTasks = { ...this.groupedTasks }; // Reset filter if query is empty or too short

      return;
    }

    this.filteredTasks = {}; // Reset before filtering

    for (let group of Object.keys(this.groupedTasks)) {
      const tasks = this.groupedTasks[group].filter(task =>
        task.courtCaseNumber.toLowerCase().includes(query)
      );

      if (tasks.length > 0) {
        this.filteredTasks[group] = tasks;
        this.expandedGroups[group] = true; // Expand groups while searching
      }
    }

    this.changeDetectorRef.markForCheck(); // Force UI update
  }

  toggleFilterTextbox() {
    this.showFilterTextbox = !this.showFilterTextbox;
    if (this.showFilterTextbox) {
      this.showFilterIcon = true;
    }
  }

  isExpired(dueDate: Date): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Ignore time part for accurate comparison
    return new Date(dueDate) < today; // Returns true if dueDate is in the past
  }
  //check Task Completed
  isCompleted(data: IAssignedTask, callback?: () => void): void {
    this.isLoading = true; // Start loading

    const reqBody: TAny = {
      "courtCaseNumber": data.courtCaseNumber,
      "dueDate": this.convertMillisecondsToFormattedDate(data.dueDate),
      "typeId": data.typeId,
      "typeName": data.typeName,
      "tasksId": data.tasksId,
      "docId": data.docId,
      "hearingDate": data.hearingDate,
      "courtLevel": data.courtLevel,
      "caseCategory": data.caseCategory,
      "categoryId": data.categoryId,
      "divisionId": data.divisionId,
      "cphId": data.cphId,
      "taskDetails": data.taskDetails
    };

    this.assignTaskService.IsTaskCompleted(reqBody).subscribe({
      next: (res: TaskModel) => {
        if (res) {
          //console.log('Task Completed:', res.isTaskCompleted);
          this.isTaskCompleted.set(res.isTaskCompleted);

          if (res.isTaskCompleted) {
            // Show Dialog Box if Task is Already Completed
            this.dialogService.openDialog1({
              data: {
                title: "info",
                message: "This task has already been completed. No further action is required.",
                icon: 'info',
              }, disableClose: true,           // Prevents closing on outside click or ESC
              hasBackdrop: true,            // Shows backdrop to block interaction
              backdropClass: 'dialog-backdrop', // Optional: custom styling
            });
          } else {
            // Proceed with callback function if the task is NOT completed
            if (callback) {
              callback();
            }
          }
        } else {
          console.warn('No task data found.');
          this.isTaskCompleted.set(false);
        }
        this.isLoading = false; // Stop loading after processing
      },
      error: (err) => {
        console.error('Error fetching task status:', err);
        this.isLoading = false; // Stop loading on error
      }
    });
  }

  // ✅ Updated function: Calls `isCompleted()` first, then proceeds only if task is NOT completed
  caseNumberClick(row: IAssignedTask) {
    this.isCompleted(row, () => {
      // This will only execute if the task is NOT completed
      this.selectedRow = row;
      this.assignTaskService.assignTaskClick(row);
    });
  }

  private groupTasks(tasks: IAssignedTask[]) {
    this.groupedTasks = {};
    this.expandedGroups = {};

    // 1️⃣ Group tasks by their type name
    tasks.forEach(task => {
      if (!task.courtCaseNumber) return;
      const groupName = this._getGroupName(task);

      if (!this.groupedTasks[groupName]) {
        this.groupedTasks[groupName] = [];
        this.expandedGroups[groupName] = false;
      }

      this.groupedTasks[groupName].push(task);
    });

    // 2️⃣ Sort tasks inside each group by dueDate descending
    for (let groupName in this.groupedTasks) {
      this.groupedTasks[groupName].sort((a, b) => {
        const dateA = new Date(a.dueDate).getTime();
        const dateB = new Date(b.dueDate).getTime();
        return dateB - dateA; // latest first
      });
    }

    // 3️⃣ Sort the groups by the latest due date in each group descending
    const sortedGroupEntries = Object.entries(this.groupedTasks).sort((a, b) => {
      const latestA = a[1].length > 0
        ? a[1].reduce((latest, item) =>
          new Date(item.dueDate).getTime() > new Date(latest.dueDate).getTime() ? item : latest)
        : { dueDate: new Date(0) };

      const latestB = b[1].length > 0
        ? b[1].reduce((latest, item) =>
          new Date(item.dueDate).getTime() > new Date(latest.dueDate).getTime() ? item : latest)
        : { dueDate: new Date(0) };

      return new Date(latestB.dueDate).getTime() - new Date(latestA.dueDate).getTime();
    });

    // 4️⃣ Rebuild the groupedTasks in this new order
    this.groupedTasks = {};
    sortedGroupEntries.forEach(([groupName, tasks]) => {
      this.groupedTasks[groupName] = tasks;
    });

    // 5️⃣ Copy to filteredTasks to initialize display
    this.filteredTasks = { ...this.groupedTasks };
  }

  getFilteredTasksByCategory(group: string, category: string) {
    return (this.filteredTasks[group] || []).filter(
      (task: any) => task.caseCategory === category
    );
  }
  sortGroupedTasks() {
    const sortedGroups: { [groupName: string]: IAssignedTask[] } = {};

    Object.keys(this.groupedTasks).forEach(groupName => {
      sortedGroups[groupName] = [...this.groupedTasks[groupName]].sort((a, b) => {
        const key = this.sortBy as keyof IAssignedTask;

        let valueA = a[key] ?? '';
        let valueB = b[key] ?? '';

        if (key === 'dueDate') {
          valueA = new Date(valueA).getTime();
          valueB = new Date(valueB).getTime();
        } else if (typeof valueA === 'string' && typeof valueB === 'string') {
          valueA = valueA.toLowerCase();
          valueB = valueB.toLowerCase();
        }

        return this.sortAscending ? (valueA > valueB ? 1 : -1) : (valueA < valueB ? 1 : -1);
      });
    });

    this.filteredTasks = { ...sortedGroups }; // Ensure change detection
    this.changeDetectorRef.detectChanges(); // Force UI update
  }

  // Toggle Sorting Order
  toggleSort(column: string) {
    if (this.sortBy === column) {
      this.sortAscending = !this.sortAscending;
    } else {
      this.sortBy = column;
      this.sortAscending = true;
    }

    const sortedTasks: { [groupName: string]: IAssignedTask[] } = {};

    Object.keys(this.filteredTasks).forEach(group => {
      sortedTasks[group] = [...this.filteredTasks[group]].sort((a, b) => {
        let valueA = a[column as keyof IAssignedTask] ?? '';
        let valueB = b[column as keyof IAssignedTask] ?? '';

        if (column === 'dueDate') {
          valueA = new Date(valueA).getTime();
          valueB = new Date(valueB).getTime();
        } else if (typeof valueA === 'string' && typeof valueB === 'string') {
          valueA = valueA.toLowerCase();
          valueB = valueB.toLowerCase();
        }

        return this.sortAscending ? (valueA > valueB ? 1 : -1) : (valueA < valueB ? 1 : -1);
      });
    });

    this.filteredTasks = { ...sortedTasks }; // Ensure change detection
    this.changeDetectorRef.detectChanges(); // Force UI update
  }



  toggleGroup(groupName: string) {
    this.expandedGroups[groupName] = !this.expandedGroups[groupName];
  }

  applyFilter(filterValue: string): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getFilteredTaskKeys(category?: string): string[] {
    const tasks = this.filteredTasks || {};
    return Object.keys(tasks).filter(group => {
      const groupTasks = tasks[group];
      if (!category) return groupTasks.length > 0;
      return groupTasks.some((task: any) => task.caseCategory === category);
    });
  }

  private _getGroupName(task: IAssignedTask): string {
    const typeName = task?.typeName?.trim();

    if (typeName && typeName.toUpperCase() === "JUDGE ASSIGNMENT") {
      return "Ready For Assignment";
    }

    return typeName || 'Other Tasks';
  }
  private isToday(dte: Date): boolean {
    const today = new Date();
    return (
      dte.getFullYear() === today.getFullYear() &&
      dte.getMonth() === today.getMonth() &&
      dte.getDate() === today.getDate()
    );
  }

  onRowHover(row: any): void {
    this.hoveredRow = row;
  }
  get groupedTaskKeys(): string[] {
    return Object.keys(this.groupedTasks);
  }
  clearFilter() {
    this.filterValue = '';
    this.applyFilter(this.filterValue); // Trigger the filter logic with an empty string
  }

  toggleCalendar(): void {

    this.calendarExpanded = !this.calendarExpanded;

    if (this.calendarExpanded) {
      this.isCalendorLoading = false;
      setTimeout(() => {
        this.isCalendorLoading = true;
      }, 0);
    }
  }

  onDateSelected(date: Date): void {
    this.selectedDate = date;
    this.startAtDate = date;
    const formattedDate = this.formatDate(date);
    //console.log('Selected Date:', formattedDate);
    this.calenderCaseService.navigateToRoute('/dashboard/calender-details', { date: formattedDate });
  }

  private formatDate(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }
  convertMillisecondsToFormattedDate(timestamp: number | Date): string {
    const date = timestamp instanceof Date ? timestamp : new Date(timestamp);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }

  clearDate() {
    this.searchDate = null;
  }

  searchByCaseNo() {
    // Your logic here
  }

  searchByPartyId() {
    // Your logic here
  }

  searchByPartyName() {

    this.selectedDate = null;
    const dialogRef = this.dialog.open(AddPartyDialogComponent, {
      data: { section: 'party-name', searchQuery: this.searchPartyName, multi: false, route: true, isCourtStaff: false },
      disableClose: true,           // Prevents closing on outside click or ESC
      hasBackdrop: true,            // Shows backdrop to block interaction
      backdropClass: 'dialog-backdrop', // Optional: custom styling
    });
  }
  onFilingDateChange(event: MatDatepickerInputEvent<Date>): void {
    this.selectedDate = event.value;
    this.searchPartyName = '';



    if (this.selectedDate) {
      const formatted = this.selectedDate.toString(); // ✅ Outputs in required format

      const body: ICaseSearchRequestBody = {
        caseNumber: "",
        dateOfFiling: formatted
      };




      // Call backend to get cases based on selected date
      this.assignTaskService.searchCase(body).subscribe({
        next: (res: IResponse<any[]>) => {
          if (res?.data?.length) {
            this.openCaseSelectionDialog(res.data);
          } else {
            this.dialogService.openDialog1({
              data: {
                title: 'No Cases Found',
                message: 'There are no cases available for the selected date.',
                icon: 'info'
              }, disableClose: true,           // Prevents closing on outside click or ESC
              hasBackdrop: true,            // Shows backdrop to block interaction
              backdropClass: 'dialog-backdrop', // Optional: custom styling
            });
          }
        },
        error: () => {
          console.error('Error fetching cases for selected date');
        }
      });
    }
  }
  openCaseSelectionDialog(caseList: any[]): void {
    const dialogRef = this.dialog.open(CaseNumberDialogComponent, {
      data: { caseList },
      disableClose: true,           // Prevents closing on outside click or ESC
      hasBackdrop: true,            // Shows backdrop to block interaction
      backdropClass: 'dialog-backdrop', // Optional: custom styling
    });

    dialogRef.afterClosed().subscribe(selectedCase => {
      if (selectedCase) {
        //console.log('Selected Case:', selectedCase);
        // Handle the selected case here (e.g., navigate or process)
      }
    });
  }

}
